module.exports = __webpack_public_path__ + "static/media/product_hunt_clone.4bef4c3e.webp";